// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-navigation-drawer {
  -webkit-overflow-scrolling: touch;
  background: rgb(var(--v-theme-surface));
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 100%;
  pointer-events: auto;
  transition-duration: 0.2s;
  transition-property: box-shadow, transform, visibility, width, height, left, right, top, bottom;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute;
}
:where(.vuetify-styles) .v-navigation-drawer {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
}
:where(.vuetify-styles) .v-navigation-drawer--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-navigation-drawer {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-navigation-drawer {
  background: rgb(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}
@media (prefers-reduced-motion: reduce) {
  :where(.vuetify-styles) .v-navigation-drawer {
    transition: none;
  }
}
:where(.vuetify-styles) .v-navigation-drawer--rounded {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-navigation-drawer--top {
  top: 0;
  border-bottom-width: thin;
}
:where(.vuetify-styles) .v-navigation-drawer--bottom {
  left: 0;
  border-top-width: thin;
}
:where(.vuetify-styles) .v-navigation-drawer--left {
  top: 0;
  left: 0;
  right: auto;
  border-right-width: thin;
}
:where(.vuetify-styles) .v-navigation-drawer--right {
  top: 0;
  left: auto;
  right: 0;
  border-left-width: thin;
}
:where(.vuetify-styles) .v-navigation-drawer--floating {
  border: none;
}
:where(.vuetify-styles) .v-navigation-drawer--temporary.v-navigation-drawer--active {
  box-shadow: 0px 8px 10px -5px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 16px 24px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 6px 30px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-navigation-drawer--sticky {
  height: auto;
  transition: box-shadow, transform, visibility, width, height, left, right;
}
:where(.vuetify-styles) .v-navigation-drawer .v-list {
  overflow: hidden;
}

:where(.vuetify-styles) .v-navigation-drawer__content {
  flex: 0 1 auto;
  height: 100%;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

:where(.vuetify-styles) .v-navigation-drawer__img {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
}
:where(.vuetify-styles) .v-navigation-drawer__img img:not(.v-img__img) {
  height: inherit;
  object-fit: cover;
  width: inherit;
}

:where(.vuetify-styles) .v-navigation-drawer__scrim {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.2;
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
}

:where(.vuetify-styles) .v-navigation-drawer__prepend,
:where(.vuetify-styles) .v-navigation-drawer__append {
  flex: none;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VNavigationDrawer/VNavigationDrawer.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,+FAA+F;EAC/F,wDAAwD;EACxD,kBAAkB;AACpB;AACA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sOAAsO;AACxO;AACA;EACE,uCAAuC;EACvC,sEAAsE;AACxE;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,MAAM;EACN,yBAAyB;AAC3B;AACA;EACE,OAAO;EACP,sBAAsB;AACxB;AACA;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,MAAM;EACN,UAAU;EACV,QAAQ;EACR,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,2OAA2O;AAC7O;AACA;EACE,YAAY;EACZ,yEAAyE;AAC3E;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;AACb;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,qDAAqD;EACrD,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB","sourcesContent":[".v-navigation-drawer {\n  -webkit-overflow-scrolling: touch;\n  background: rgb(var(--v-theme-surface));\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-width: 100%;\n  pointer-events: auto;\n  transition-duration: 0.2s;\n  transition-property: box-shadow, transform, visibility, width, height, left, right, top, bottom;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  position: absolute;\n}\n.v-navigation-drawer {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0;\n}\n.v-navigation-drawer--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-navigation-drawer {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-navigation-drawer {\n  background: rgb(var(--v-theme-surface));\n  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));\n}\n@media (prefers-reduced-motion: reduce) {\n  .v-navigation-drawer {\n    transition: none;\n  }\n}\n.v-navigation-drawer--rounded {\n  border-radius: 4px;\n}\n.v-navigation-drawer--top {\n  top: 0;\n  border-bottom-width: thin;\n}\n.v-navigation-drawer--bottom {\n  left: 0;\n  border-top-width: thin;\n}\n.v-navigation-drawer--left {\n  top: 0;\n  left: 0;\n  right: auto;\n  border-right-width: thin;\n}\n.v-navigation-drawer--right {\n  top: 0;\n  left: auto;\n  right: 0;\n  border-left-width: thin;\n}\n.v-navigation-drawer--floating {\n  border: none;\n}\n.v-navigation-drawer--temporary.v-navigation-drawer--active {\n  box-shadow: 0px 8px 10px -5px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 16px 24px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 6px 30px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-navigation-drawer--sticky {\n  height: auto;\n  transition: box-shadow, transform, visibility, width, height, left, right;\n}\n.v-navigation-drawer .v-list {\n  overflow: hidden;\n}\n\n.v-navigation-drawer__content {\n  flex: 0 1 auto;\n  height: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.v-navigation-drawer__img {\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: -1;\n}\n.v-navigation-drawer__img img:not(.v-img__img) {\n  height: inherit;\n  object-fit: cover;\n  width: inherit;\n}\n\n.v-navigation-drawer__scrim {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: black;\n  opacity: 0.2;\n  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 1;\n}\n\n.v-navigation-drawer__prepend,\n.v-navigation-drawer__append {\n  flex: none;\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
